<template>

<div class="default-container">
    <div v-if="datasNegociosList.length == 0" class="no-content mb-4">
        Nenhum negócio encontrado
    </div>
    <div v-for="(datas, indexData) in (datasNegociosList)" :key="indexData">
        <div class="row">
            <div class="col-12">
                <div class="section mt-3">
                    <span>{{ datas.data }}</span>
                </div>
            </div>
        </div>
        <div class="mainbox" v-for="(negocio, index) in datas.negocios" :key="index">
            <div class="row p-2">
                <div class="col-auto text-center">
                    <div class="list-icon">
                        <i class="fa fa-dollar" aria-hidden="true"></i>
                    </div>
                </div>
                <div class="col-md-5 col-12">
                    <span class="list-title">{{ negocio.titulo }}</span>
                    <span class="tag-input-color float-right" :style="'background-color: ' + negocio.tag_cor">{{ negocio.tag_descricao }} </span>
                    <span v-if="negocio.stnegocio == 'G'" class="badge badge-green float-right pr-2">GANHO</span>
                    <span v-if="negocio.stnegocio == 'P'" class="badge badge-red float-right pr-2">PERDIDO</span>
                    <span v-if="negocio.excluido=='S'" class="badge badge-red ml-2">Excluído</span>
                    <div class="w-100"></div>
                    <span class="lbl-list-detalhe"><i class="fa fa-calendar pr-2" aria-hidden="true"></i> {{ negocio.data | formatDataHoraExtenso }}</span>
                    <span class="lbl-list-detalhe"><i class="fa fa-user-circle pr-2" aria-hidden="true"></i> {{ negocio.nome_usuario }}</span>
                    <div class="w-100"></div>
                    <span class="data-list"><i class="fa fa-user" style="width: 20px;" aria-hidden="true"></i>{{ negocio.pessoa_nome }}</span>
                    <div class="w-100"></div>
                    <span class="data-list"><i class="fa fa-university" style="width: 20px;" aria-hidden="true"></i>{{ negocio.org_nome }}</span>
                    <!-- <span v-if="negocio.organizacao.length>0" class="lbl-list w-100" :href="'#/crm/organizacao/'+negocio.codorg"><i class="fa fa-university pr-2" aria-hidden="true"></i> {{ negocio.organizacao[0].nome }}</span> -->
                </div>
                <div class="col-md-2 col-3">
                    <span class="lbl-list w-100"> {{metadata.negociocrm.valor.label}} </span>
                    <span class="data-list w-100">{{ negocio.valor | formatValue(2) }}</span>
                </div>
                <!-- <div class="col-md-2 col-3">
                    <span class="lbl-list"> {{metadata.negociocrm.dataprevista.label}} </span>
                    <span class="data-list">{{ negocio.dataprevista | formatData }}</span>
                </div> -->
                <div class="col-md-2 col-4">
                    <span class="icon icon-atrasado" v-if="negocio.dias_atividade>0" :title="'Atividade atrasada há ' + negocio.dias_atividade + ' dias'" data-toggle="tooltip" data-placement="top"><i class="fa fa-calendar" aria-hidden="true"></i></span>
                    <span class="icon icon-sem-agenda" v-if="negocio.count_agenda == 0" data-toggle="tooltip" data-placement="top" title="Nenhuma atividade"><i class="fa fa-warning" aria-hidden="true"></i></span>
                    <span class="icon icon-agenda" v-if="negocio.count_agenda > 0 && negocio.dias_atividade <= 0" data-toggle="tooltip" data-placement="top" title="Atividade planejada"><i class="fa fa-calendar" aria-hidden="true"></i></span>
                    <label class="lbl-list icon-sem-agenda" v-if="!negocio.proxima_atividade">Sem Atividade</label>
                    <span class="data-list" :style="handleStyleAgenda(negocio)"> {{ formatDate(negocio.proxima_atividade) }} </span>
                </div>
                <div class="col-auto ml-auto">
                    <bar-grid 
                        :options="{barDefault: true, btnDelete: false, btnEdit: true}" 
                        :moreActions="[]" 
                        @edit="handleEditNegocio(negocio.codnegocio)" 
                        @view="handleEditNegocio(negocio.codnegocio, true)"
                        @delete="handleDelete(negocio)">
                    </bar-grid>
                </div>
            </div>
        </div>
    </div>
    <div>
        <a v-if="nextPage>0" style="cursor: pointer; color: #0091ea;" @click="handleMore()">Exibir mais</a>
    </div>

</div>

</template>

<script>
import { SysVars } from '../main';
import { apiDateORDS } from '../shared/api-functions'
import { formatDataExtenso, formatDataHoraExtenso, getText, formatDate, formatValue } from '../shared/utils'
import { objectToCsv, downloadCsvReport } from '../shared/csvReport'
import apiCrm from '../api/api-crm.js'

export default {
    props: {
        funil: Object,
        usuario: Object,
        equipe: Object,
        startDate: '',
        filtro: '',  //código do filtro selecionado
    },

    components: {
    },

    mixins: [apiCrm],  //ROTINAS DO CRM

    data () {
        return {
            metadata: this.$store.getters.getEntities.metadata,

            selectedIndex: -1,

            etapasFunil: [],

            negociocrm: null,

            offset: false,
            
        }
    },

    computed: {
        nextPage: function () {
            return this.$store.getters.getNextPage
        },

        totalList: function () {
            return this.$store.getters.getNegocioTotais[0]
        },

        negocioList: function () {
            return this.$store.getters.getNegocioList
        },

        organizacao: function () {
            if (this.negociocrm && this.negociocrm.organizacao.length > 0)
              return this.negociocrm.organizacao[0]
            else 
              return null
        },

        pessoa: function () {
            if (this.negociocrm && this.negociocrm.pessoa.length > 0)
              return this.negociocrm.pessoa[0]
            else 
              return null
        },

        datasNegociosList: function () {
            let datas = [...new Set(this.negocioList.map(item => formatDataExtenso(item.data)))]
            let datasNegocios = []
            for (var x = 0; x < datas.length; x++) {
                datasNegocios.push( {
                    data: datas[x],
                    negocios: this.negocioList.filter((obj) => {
                        return formatDataExtenso(obj.data) == datas[x]
                    })
                } )
            }
            return datasNegocios
        }

    },

    watch: {
        startDate: function (value) {
            this.loadData()
        },

        funil: function (value) {
            //se o filtro de funil for alterado
            this.loadData()
        },

        usuario: function (value) {
            //se o filtro de usuario for alterado
            this.loadData()
        },

        equipe: function (value) {
            //se o filtro de equipe for alterado
            this.loadData()
        },

        filtro: function (value) {
            //se o filtro for alterado
            this.loadData()
        },
    },

    methods: {
        data (value) {
            return formatDate(value)
        },        

        formatDate (value) {
            return formatDataHoraExtenso(value, true)
        },

        handleStyleAgenda(obj) {
            if (obj.dias_atividade > 0)
              return 'color: red;';
            else 
            if (obj.dias_atividade < 0)
              return 'color: green;'
            else  
              return ''
        },

        handleExportarPlanilha () {
            //exportar a lista de notas para planilha
            const data = this.negocioList.map(negocio => ({
                data: this.data(negocio.data),
                titulo: negocio.titulo,
                pessoa: negocio.pessoa_nome,
                valor: formatValue(negocio.valor,2)
            }))
            const csv = objectToCsv(data)
            downloadCsvReport(csv)
        },

        handleEditNegocio (codnegocio) {
            //ABRIR FORM PARA DIGITACAO
            this.$emit('edit', codnegocio)
        },

        async loadData () {


            this.etapasFunil = this.funil.etapas

            let query = ''

            if (this.filtro) {
              if (query)
                query = query + '&'
              query = query + 'filtro=' + this.filtro
            }

            if (this.usuario) {
              if (query)
                query = query + '&'
              query = query + 'codusuario=' + this.usuario
            }

            if (this.equipe) {
              if (query)
                query = query + '&'
              query = query + 'codequipe=' + this.equipe
            }

            if (this.startDate) {
              if (query)
                query = query + '&'
              query = query + 'data=' + apiDateORDS(this.startDate)
            }

            let params = { codfunil: this.funil.codfunil, tipo: 'lista', query: query }
            if (this.offset) {
                params.offset = this.nextPage
            }

            await this.$store.dispatch('loadPainelCrm', params)

            console.log(this.datasNegociosList)

            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })

        },

        handleMore () {
            this.offset = true
            this.loadData()
        },

    },

    filters: {

    },

    created () {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip()
        })

        this.loadData()
    }
  
}
</script>

<style>


.list-title {
    display: inline-block;
    max-width: 100%;
    /* font-size: 16px; */
    font-weight: 700;
    color: #4993d2;
}

.list-icon {
    font-size: 24px; 
    align-items: center; 
    justify-content: center; 
    background-color: #f5f5f5; 
    border: solid 1px #E0E0E0; 
    box-sizing: border-box; 
    height: 38px; 
    width: 42px; 
    flex-shrink: 0;
}

</style>






// WEBPACK FOOTER //
// src/forms-crm/crm-painel-list.vue